import { SidebarBackButton } from 'wix-style-react';
import { config } from '../../config';
import * as React from 'react';
import { composer } from '../../component-decorators/composer';
import { biLogger } from '../../bi';
import { getPathForBi } from '../../common/bi-events';
export var BackMenuItem = composer()
    .withTranslation()
    .withMarketplaceStore()
    .compose(function (_a) {
    var t = _a.t, marketplaceStore = _a.marketplaceStore;
    var _b = config.goBackToReferrer, labelKey = _b.labelKey, referrerNameForBI = _b.referrerNameForBI, navigation = _b.navigation;
    var _c = marketplaceStore.route, slug = _c.slug, query = _c.query, path = _c.path;
    var metaSiteId = marketplaceStore.metaSiteId;
    function sendBackToReferrerBi() {
        biLogger.appMarketMenuNavigation({
            menu_item_label: t(labelKey),
        });
        biLogger.appMarketBackToManageApps5({
            click_origin: 'top',
            msid: metaSiteId,
            tag_name: (slug || query || 'homepage').replace(/-/g, '_'),
            tag_type: getPathForBi(path),
            referral_name: referrerNameForBI,
        });
    }
    function onBackClick() {
        sendBackToReferrerBi();
        navigation();
    }
    return (React.createElement(SidebarBackButton, { dataHook: "back-button", onClick: onBackClick }, t(labelKey)));
});
//# sourceMappingURL=back-menu-item.js.map